<template>
    <div
        class="wrapper"
        ref="wrapperRef"
    >
        <div class="top-page">
            <h2 class="header-title">{{ $t("page.tariffs.title.value") }}</h2>
        </div>
        <div class="container-body">
            <div class="switch-block">
                <div class="tariffs">
                    <TariffsBlock/>
                </div>
                <transition name="fade">
                    <SelectedNumbersTariffs
                        v-if="currentTab === 'payment'"
                        :updatedData="calculateTariffData"
                        @calculatePayloadUpdated="handleCalculatePayload"
                        @changedTableData="assignWrapperHeight"
                    />
                </transition>
                <transition name="fade">
                    <CalculatorTariffs
                        v-if="currentTab === 'calculator'"
                        :tariffPriceOfMonth="costOfOneNumberOneMonth"
                        :updatedData="calculateTariffData"
                        @calculatePayloadUpdated="handleCalculatePayload"
                    />
                </transition>
            </div>
            <div
                class="calculator-block"
                :class="{
                'flex-end': heightWindowState?.scroll + heightWindowState.height > wrapperHeight + 88
            }"
            >
                <finally-calculation
                    :btn="currentTab"
                    :yPosition="heightWindowState?.scroll"
                    :wrapperHeight="wrapperHeight"
                    :calculateData="calculateTariffData"
                    @priceOneNumberOneMonth="setPriceOneNumberOneMonth"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
// core
import {watchEffect, computed, ref} from "vue";
import {useWindowScroll, useWindowSize} from '@vueuse/core'
import {useRoute} from "vue-router";
import {useStore} from "vuex";

// components
import TariffsBlock from "@/components/Tariffs/TariffsBlock.vue";
import CalculatorTariffs from "@/components/Tariffs/CalculatorTariffs.vue";
import SelectedNumbersTariffs from "@/components/Tariffs/SelectedNumbersTariffs.vue";
import FinallyCalculation from "@/components/Tariffs/FinallyCalculation.vue";

const route = useRoute();
const store = useStore();

const wrapperRef = ref(null);
const wrapperHeight = ref(null);

const calculateTariffData = ref({
    count: {
        months: 1,
        viber: 0,
        telegram: 0,
        whatsapp: 0,
    },
    viber: [],
    telegram: [],
    whatsapp: [],
})

const costOfOneNumberOneMonth = ref({
    viber: 0,
    telegram: 0,
    whatsapp: 0,
})

const currentTab = computed(() => {
    return route?.query?.tab || 'payment'
})

const heightWindowState = computed(() => {
    const {height} = useWindowSize();
    const {y} = useWindowScroll();
    assignWrapperHeight()
    return {height: height.value, scroll: y.value}
})

const setPriceOneNumberOneMonth = (payload) => {
    costOfOneNumberOneMonth.value = {...payload};
}

const handleCalculatePayload = (payload) => {
    store.commit('numbers/SET_SELECTED_NUMBERS', payload)
    calculateTariffData.value = {
        ...calculateTariffData.value,
        ...payload
    }
}

const assignWrapperHeight = () => {
    wrapperHeight.value = wrapperRef.value?.offsetHeight;
}

watchEffect(assignWrapperHeight)
</script>

<style lang="scss" scoped>
.header-title {
    text-transform: uppercase;
    font-size: 24px;
    font-weight: 500;
}

.wrapper {
    margin: 20px;
}

.top-page {
    display: flex;
    justify-content: flex-start;
    gap: 25px;
    margin-bottom: 30px;

    button {
        background: var(--block-color);
        padding: 5px;
        // height: 55px;
        max-width: 300px;
        width: 100%;
        font-size: 20px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        -webkit-box-shadow: -10px 8px 32px -5px rgba(0, 0, 0, 0.75);
        -moz-box-shadow: -10px 8px 32px -5px rgba(0, 0, 0, 0.75);
        box-shadow: -10px 8px 32px -5px rgba(0, 0, 0, 0.75);
    }

    .active {
        color: white;
        background: var(--general-color);

        span {
            color: white;
        }
    }
}

.container-body {
    position: relative;
    width: 100%;
    display: flex;
    min-height: 100%;
    gap: 20px;

    .switch-block {
        width: initial;
    }

    .calculator-block {
        position: relative;
        min-width: 260px;
        max-width: 467px;
        width: 100%;
        align-self: stretch;
        transition: align-self 0.8s cubic-bezier(0, 0.17, 0.07, 1.65);
    }

}

.title {
    padding: 0px 15px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
        font-family: Gilroy;
        font-size: 24px;
        font-weight: 500;

        text-transform: uppercase;

        color: var(--text-color);
    }
}

button {
    cursor: pointer;

    width: 300px;
    height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;

    // font-family: $gilroy;
    font-size: 16px;
    font-weight: 500;

    text-transform: uppercase;

    // color: $white-color;

    box-sizing: border-box;
    border: none;
    border-radius: 11px;

    &:hover {
        cursor: pointer;
    }
}


@media screen and (max-width: 480px) {
    .container-body {
        flex-direction: column;

        .calculator-block {
            width: inherit;
        }
    }


}

@media screen and (min-width: 481px) and (max-width: 1220px) {
    .container-body {

        flex-direction: column;
        align-items: center;

        .calculator-block {
            width: 100%;
            max-width: none;
        }
    }
}
</style>
